import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'
import {ClassifiedTable} from './ClassifiedTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PostEditModal} from './post-add-edit/PostEditModal'
import {ListViewProvider, useListView} from './core/ListViewProvider'

const ClassifiedList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <ClassifiedTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PostEditModal />}
    </>
  )
}

const ClassifiedListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ClassifiedList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ClassifiedListWrapper}
